export function getLocaleForLanguage(language = 'en') {
  return language === 'ar' ? 'ar-JO' : 'en-JO';
}

const LATIN_NUMERALS = { numberingSystem: 'latn' };

export function formatLocalizedDateTime(value, language = 'en', options = {}) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleString(getLocaleForLanguage(language), {
    ...options,
    ...LATIN_NUMERALS,
  });
}

export function formatLocalizedTime(value, language = 'en', options = {}) {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleTimeString(getLocaleForLanguage(language), {
    ...options,
    ...LATIN_NUMERALS,
  });
}

/** Compact clinical timestamp: "15 Jul 08:00" (no shift labels). */
export function formatClinicalDateTime(value, language = 'en') {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  const dayMonth = date.toLocaleDateString(getLocaleForLanguage(language), {
    day: 'numeric',
    month: 'short',
    ...LATIN_NUMERALS,
  });
  const time = date.toLocaleTimeString(getLocaleForLanguage(language), {
    hour: '2-digit',
    minute: '2-digit',
    hour12: false,
    ...LATIN_NUMERALS,
  });
  return `${dayMonth} ${time}`;
}

/** Calendar day label: "15 Jul 2026". */
export function formatClinicalCalendarDay(value, language = 'en') {
  const date = value instanceof Date ? value : new Date(value);
  if (Number.isNaN(date.getTime())) return '';
  return date.toLocaleDateString(getLocaleForLanguage(language), {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
    ...LATIN_NUMERALS,
  });
}
